<template>
<md-toolbar id="toolbar" md-elevation="0" class="md-fixed" :class="{
      [`md-${type}`]: !navbarTransparent,
      [extraNavClasses]: navbarTransparent,
      'md-transparent': navbarTransparent
    }" :color-on-scroll="colorOnScroll">
    <div class="md-toolbar-row md-collapse-lateral">
        <div class="md-toolbar-section-start">
            <h3 class="md-title">
                {{ brand }}
            </h3>
        </div>
        <div class="md-toolbar-section-end">
            <md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: toggledClass }" @click="toggleNavbarMobile()">
                <span class="icon-bar" />
                <span class="icon-bar" />
                <span class="icon-bar" />
            </md-button>

            <div class="md-collapse">
                <div class="md-collapse-wrapper">
                    <mobile-menu nav-mobile-section="false">
                        <!-- Here you can add your items from the section-start of your toolbar -->
                    </mobile-menu>
                    <md-list>
                        <li class="md-list-item">
                            <a href="javascript:void(0)" class="md-list-item-router md-list-item-container md-button-clean dropdown">
                                <div class="md-list-item-content">
                                    <drop-down direction="down">
                                        <md-button slot="title" class="md-button md-button-link md-white md-simple dropdown-toggle" data-toggle="dropdown">
                                            <i class="material-icons">shopping_basket</i>
                                            <p>Dorfläden</p>
                                        </md-button>
                                        <ul class="dropdown-menu dropdown-with-icons">
                                            <li v-for="dorfladen in userListGetter" :key="dorfladen.id">
                                                <router-link :to='"/dorfladen/" + dorfladen.id'>
                                                    {{ dorfladen.name }}
                                                </router-link>
                                            </li>
                                        </ul>
                                    </drop-down>
                                </div>
                            </a>
                        </li>
                        <li class="md-list-item">
                            <a href="javascript:void(0)" class="md-list-item-router md-list-item-container md-button-clean dropdown">
                                <div class="md-list-item-content">
                                    <drop-down direction="down">
                                        <md-button slot="title" class="md-button md-button-link md-white md-simple dropdown-toggle" data-toggle="dropdown">
                                            <i class="material-icons">info</i>
                                            <p>mehr...</p>
                                        </md-button>
                                        <ul class="dropdown-menu dropdown-with-icons">
                                            <li>
                                                <router-link to="/">Start</router-link>
                                            </li>
                                            <li>
                                                <router-link to="impressum">Impressum</router-link>
                                            </li>
                                            <li>
                                                <router-link to="datenschutz">Datenschutzerklärung</router-link>
                                            </li>
                                            <li>
                                                <a href="https://admin.dorfladen.app">Admin-Login</a>
                                            </li>
                                        </ul>
                                    </drop-down>
                                </div>
                            </a>
                        </li>
                    </md-list>
                </div>
            </div>
        </div>
    </div>
</md-toolbar>
</template>

<script>
let resizeTimeout;

function resizeThrottler(actualResizeHandler) {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            actualResizeHandler();

            // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
    }
}

import MobileMenu from "@/layout/MobileMenu";
import {
    mapGetters
} from "vuex";
export default {
    components: {
        MobileMenu
    },
    props: {
        type: {
            type: String,
            default: "white",
            validator(value) {
                return [
                    "white",
                    "default",
                    "primary",
                    "danger",
                    "success",
                    "warning",
                    "info",
                    "dark"
                ].includes(value);
            }
        },
        colorOnScroll: {
            type: Number,
            default: 0
        },
        navbarTransparent: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            extraNavClasses: "",
            toggledClass: false,
            brand: "dorfladen.app"
        };
    },
    computed: {
        ...mapGetters(["userListGetter"])
    },
    mounted() {
        this.$store.dispatch("getUserList").then(result => {});
        document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.scrollListener);
    },
    methods: {
        bodyClick() {
            let bodyClick = document.getElementById("bodyClick");

            if (bodyClick === null) {
                let body = document.querySelector("body");
                let elem = document.createElement("div");
                elem.setAttribute("id", "bodyClick");
                body.appendChild(elem);

                let bodyClick = document.getElementById("bodyClick");
                bodyClick.addEventListener("click", this.toggleNavbarMobile);
            } else {
                bodyClick.remove();
            }
        },
        toggleNavbarMobile() {
            this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
            this.toggledClass = !this.toggledClass;
            this.bodyClick();
        },
        handleScroll() {
            let scrollValue =
                document.body.scrollTop || document.documentElement.scrollTop;
            let navbarColor = document.getElementById("toolbar");
            this.currentScrollValue = scrollValue;
            if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
                this.extraNavClasses = `md-${this.type}`;
                navbarColor.classList.remove("md-transparent");
            } else {
                if (this.extraNavClasses) {
                    this.extraNavClasses = "";
                    navbarColor.classList.add("md-transparent");
                }
            }
        },
        scrollListener() {
            resizeThrottler(this.handleScroll);
        }
    }
};
</script>
